import React, { useState } from 'react';
import Tabs from './Tabs';
import Accordion from './Accordion';
import './App.css';
import logo from './logo.png';
import max from './max.png';

// 각 탭에 들어갈 Q&A 데이터 정의
const qnaData = {
  tab1: [
    {
      id: 'q1',
      question: 'How do I communicate with Maxwell English staff?',
      answer: (
        <>
          A: We use Microsoft Teams as our main communication tool. Please follow these steps:
          <br /><br />
          <strong>Download Microsoft Teams</strong><br />
          Install Teams on your computer. You can find it by searching for “Microsoft Teams download” or go directly to the official Microsoft website.
          <br /><br />
          <strong>Create an Account</strong><br />
          Sign up for a free Microsoft account if you don’t already have one.
          <br /><br />
          <strong>Join Maxwell English on Teams</strong><br />
          Click this invitation link: Join Maxwell English on Teams
          This will connect you directly to the Maxwell English staff chat.
          <br /><br />
          <strong>Introduce Yourself</strong><br />
          Once you’ve joined, send a short message in the chat, for example:
          “Hello, my name is Jene. I learned about Maxwell through Tom.”
          After you send this message, one of our staff members will confirm and start a conversation with you.
        </>
      ),
    },
    {
      id: 'q2',
      question: 'What do we call students and teachers at Maxwell English (MWE)?',
      answer: (
        <>
          A: Learners are referred to as “students”, and those who teach are called “tutors.” However, during class, it’s natural for tutors to introduce themselves as “teacher” and for students to call you “teacher” as well.
        </>
      ),
    },
    {
      id: 'q3',
      question: 'What platform are the classes conducted on?',
      answer: (
        <>
          A: All classes are conducted via Zoom. Please make sure to install Zoom before your first lesson.
          <br />
          <a
            href="https://zoom.us/download"
            target="_blank"
            rel="noopener noreferrer"
          >
            Zoom download link
          </a>
        </>
      ),
    },
    {
      id: 'q4',
      question: 'Are there any mandatory Zoom settings?',
      answer: (
        <>
          A: Yes, the following two settings are required:
          <ul>
            <li>
              <strong>Waiting Room enabled</strong> – so that students cannot enter without your approval.
            </li>
            <li>
              <strong>Automatic recording enabled</strong> – every lesson must be recorded.
            </li>
          </ul>
        </>
      ),
    },
    {
      id: 'q5',
      question: 'What type of Zoom account should I create?',
      answer: (
        <>
          A: Please choose the <strong>“Basic (Free) Personal Use”</strong> option, not “Educator.”
        </>
      ),
    },
    {
      id: 'q6',
      question: 'What information do I need to send to MWE after setting up Zoom?',
      answer: (
        <>
          A: Please provide the following:
          <ul>
            <li>Zoom Meeting ID (numbers only)</li>
            <li>Zoom Passcode</li>
            <li>Zoom Meeting link (URL)</li>
          </ul>
        </>
      ),
    },
    {
      id: 'q7',
      question: 'What age groups are the students?',
      answer: (
        <>
          A: About half of the students are children and the other half are adults. Depending on matching, some tutors may teach only children or only adults.
          Many MWE child students come from English kindergarten backgrounds and, in most cases, speak English better than adult students.
        </>
      ),
    },
  ],

  tab2: [
    {
      id: 'q8',
      question: 'How long is each class?',
      answer: (
        <>
          A: Lessons are either 25 minutes or 50 minutes long, depending on the student’s selected plan.
          <br />
          Since Zoom’s free plan allows a maximum of 40 minutes per session, 50-minute lessons should be split into two parts. Conduct the first 25 minutes, take a 1–5 minute break, and then continue with the remaining time.
          Before ending the first session, the tutor should inform the student by saying something like, “Let’s meet again right away,” or “Please reconnect in 3 minutes.” After that, simply end the Zoom meeting and restart it after the break.
          <strong>MWE recommends restarting the lesson immediately with little to no break whenever possible.</strong>
          <br /><br />
          <strong>Important:</strong><br />
          If the first session reaches the full 40 minutes, Zoom may require a 10-minute wait before allowing a second session to start. To avoid this, please make sure no single session exceeds 30 minutes.
          <br /><br />
          While it may be acceptable to occasionally extend a lesson out of kindness or consideration for the student, tutors must still act as if they have another class scheduled right after. Please aim to finish all 25-minute lessons within <strong>28 minutes at the latest.</strong>
        </>
      ),
    },
    {
      id: 'q9',
      question: 'What happens if a student cancels or misses a class?',
      answer: (
        <>
          A: If a student cancels on the day of class and MWE informs the tutor at least 2 hours before the class, the lesson is canceled and the student receives a make-up credit.
          <br /><br />
          If a student is absent without notice, or MWE does not inform the tutor at least 2 hours in advance, the tutor will still be paid for that lesson.
        </>
      ),
    },
    {
      id: 'q10',
      question: 'What should I do if a student is late or doesn’t join?',
      answer: (
        <>
          A: If a student hasn’t joined the class within 2 minutes after the scheduled start time, please send a quick message to the MWE staff via MS Teams.
          If the student does not join:
          <ul>
            <li>Within 15 minutes (for 25-min lessons), or</li>
            <li>
              Within 30 minutes (for 50-min lessons), the class is marked as absent.
            </li>
          </ul>
          You do not need to keep your camera on while waiting.
          <strong>Please exit Zoom</strong> after the waiting period and <strong>send a message to the MWE team to report the student’s absence.</strong>
          Do not upload recordings for no-show classes.
        </>
      ),
    },
    {
      id: 'q11',
      question: 'Do all classes need to be recorded?',
      answer: (
        <>
          A: Yes. All lessons must be automatically recorded and uploaded to the Google Drive folder provided by Maxwell after class.
          <br /><br />
          Recordings are used for:
          <ul>
            <li>Student review</li>
            <li>MWE feedback on tutor performance</li>
            <li>
              Reference in case of student complaints
              <br />
              ※ Videos are deleted after 3 months.
            </li>
          </ul>
        </>
      ),
    },
    {
      id: 'q11-new',
      question: 'How should I name lesson recordings before uploading them?',
      answer: (
        <>
          A: After uploading the lesson recording to the Google Drive folder provided by MWE, you must rename the file using the following format:
          <br /><br />

          For 25-minute lessons
          <br />
          StudentName-MM/DD/YYYY.mp4
          <br /><br />
          Example:
          <br />
          Linda-04/01/2026.mp4
          <br /><br />

          For 50-minute lessons (2 recordings)
          <br />
          Since 50-minute lessons are split into two sessions, there will be two video files.
          <br /><br />
          Please name them as follows:
          <ul>
            <li>Linda-04/01/2026(1).mp4</li>
            <li>Linda-04/01/2026(2).mp4</li>
          </ul>

          Please make sure to follow this exact naming format.
          <br /><br />
          Some tutors in Europe occasionally use different date styles, but all MWE tutors must use the format instructed above for consistency and file organization purposes.
        </>
      ),
    }, {
      id: 'q11-newOne',
      question: 'What if I fail to record a lesson?',
      answer: (
        <>
          A: Recording every lesson is <strong>mandatory.</strong>
          Some students rely on recordings for review, and if you are unable to upload a recording to the student’s folder for any reason, you will be required to provide the student with a <strong>free make-up lesson,</strong> regardless of the reason.

          While many students tend to check recordings less frequently after about a month, some still rely on them, so recording every lesson is essential.
          This is especially important for <strong>new students,</strong> as most of them actively review recordings during their first one to two months. Please make sure to record all lessons without exception.
        </>
      ),
    },
    {
      id: 'q12',
      question: 'Are materials provided by MWE?',
      answer: (
        <>
          A: Most materials are available on the Maxwell English website(www.maxwellenglish.com) and Google Drive. If a student requests a specific topic, MWE may prepare customized materials.
          <br /><br />
          You’re also welcome to use your own resources if they are appropriate for the student’s level and interests.
          <br /><br />
          To help students better understand the lesson, we highly recommend that you keep <strong>Google Images</strong> and <strong>Google Translate</strong> open in your browser tabs during class and use them whenever necessary.Please feel free to screen share these resources with the student whenever it helps improve understanding.
        </>
      ),
    },
    {
      id: 'q13',
      question: 'Do I need to provide lesson notes to students?',
      answer: (
        <>
          A: Yes, please take notes during each lesson using Google Docs in the designated note folder.
          <br /><br />
          You may either:
          <br />
          <ul>
            <li>Create a new Google Doc for every class, or</li>
            <li>
              Use a single Google Doc for the entire month. The latest note should always appear at the top of the document and must include the date and day of the week. Leaving short comments or notes for the student after each class is recommended, but not strictly required.
            </li>
          </ul>
        </>
      ),
    },

  ],

  tab3: [
    {
      id: 'q14',
      question: 'What if the tutor is late?',
      answer: (
        <>
          A: If you are about 5 minutes late to a class, you must apologize to the student at the beginning of the lesson, inform them that you will extend the class by the number of minutes you were late, and then do so accordingly.
          <br /><br />
          If you expect to <strong>be more than 5 minutes late,</strong> please notify the <strong>MWE staff first.</strong> We will contact the student on your behalf and ask whether they are able to start the lesson late and finish late by the same amount of time.
          <br /><br />
          Sometimes students have other commitments immediately after the scheduled lesson time. In such cases, the lesson time cannot be adjusted, and the class will be considered a <strong>tutor no-show.</strong>
          <br /><br />
          If a tutor is late, they must inform the MWE staff immediately. If a tutor tries to handle the situation alone and MWE later learns about it from the student, <strong>three lessons will be deducted from the tutor’s class count as a penalty.</strong>
        </>
      ),
    },
    {
      id: 'q15',
      question: 'What if a tutor needs to cancel a class?',
      answer: (
        <>
          A: Sudden cancellations by tutors are taken very seriously at MWE. If you need to cancel a lesson, you must inform MWE at least 3 hours in advance. Failure to do so will result in a penalty: Double the number of affected classes will be deducted from your total class count (e.g., 1 missed class = 2 classes deducted).
        </>
      ),
    },
    {
      id: 'q16',
      question: 'What happens if the tutor no-shows?',
      answer: (
        <>
          A: Any class missed due to a tutor no-show will result in a double deduction from your total class count (the missed class itself plus an additional penalty class).
        </>
      ),
    },
    {
      id: 'q17',
      question: 'Can I take a day off or vacation?',
      answer: (
        <>
          <table className="policy-table">
            <thead>
              <tr>
                <th>Type of Absence</th>
                <th>Notice Period Required</th>
                <th>Penalty If Not Followed</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2 consecutive days off</td>
                <td>At least 3 days before</td>
                <td>10% deduction from affected class payments</td>
              </tr>
              <tr>
                <td>3-6 consecutive days off</td>
                <td>At least 7 days before</td>
                <td>15% deduction from affected class payments</td>
              </tr>
              <tr>
                <td>More than 1 week off</td>
                <td>At least 1 month before</td>
                <td>20% deduction from affected class payments</td>
              </tr>
            </tbody>
          </table>
          <br /><br />
          For example, if you need to take <b>2 days off</b> and notify MWE only <b>2 days before</b>, and you will miss a total of <b>10 classes</b>, then <b>10% of the total payment for those 10 missed classes will be deducted from your next payment.</b>
        </>
      ),
    },
    {
      id: 'q17-old',
      question: 'What happens if I cannot finish a class due to a sudden power outage or internet connection issue on my side?',
      answer: (
        <>
          A: At MWE, we understand that technical issues can occasionally happen. However, if power outages or internet connection problems occur frequently and disrupt the learning experience, we may have to discuss terminating our partnership. Reliability is a core value of our platform.
          In the rare event of a technical issue on your side, the responsibility lies with the teacher. You must provide a full 25-minute make-up class to the student at a later time. Please note that this rule applies both ways: if a student experiences technical issues on their end and cannot attend the class, they are still required to pay the teacher for that session. This ensures fairness and protects the time you have dedicated to the lesson.

        </>
      )
    },
    {
      id: 'q17-new',
      question: 'When should I inform MWE if I want to stop working?',
      answer: (
        <>
          A: A smooth transition period is extremely important because it allows us to:
          <br /><br />

          <ul>
            <li>help students adjust emotionally to the change</li>
            <li>maintain continuity in their learning progress</li>
            <li>carefully match them with a tutor whose teaching style fits their needs</li>
            <li>protect the long-term trust students have built with MWE</li>
          </ul>

          Because many of our students study with the same tutor for months or even years, this transition process requires thoughtful communication and scheduling.
          <br /><br />

          If less than 30 days’ notice is given, the following resignation fee will apply based on the <b>highest monthly payment received within the most recent 3 months.</b>

          <table className="policy-table">
            <thead>
              <tr>
                <th>Notice Period</th>
                <th>Transition Fee (to MWE)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1–7 days before leaving</td>
                <td>40%</td>
              </tr>
              <tr>
                <td>8–14 days before leaving</td>
                <td>30%</td>``
              </tr>
              <tr>
                <td>15–22 days before leaving</td>
                <td>20%</td>
              </tr>
              <tr>
                <td>23–30 days before leaving</td>
                <td>10%</td>
              </tr>
            </tbody>
          </table>

          <br /><br />
          If your remaining salary exceeds the support fee, the amount will be deducted from your final payment. If the fee exceeds your remaining balance, the difference must be sent to MWE via Wise.
          <br /><br />

        </>
      )
    },
    {
      id: 'q17-newold',
      question: 'Why are the policies regarding tardiness, absences, and leaves so strict?',
      answer: (
        <>
          A: In our early years, Maxwell English operated with a small, tight-knit group of teachers who were exceptionally responsible. Because of that deep mutual trust, we didn't need formal rules; we handled everything on a case-by-case basis.
          <br /><br />
          However, as MWE grew, we faced painful challenges. We encountered instances where a lack of professionalism—such as frequent tardiness and unannounced absences—damaged the reputation we had worked so hard to build over the years, sometimes in just a single month. We realized that without firm policies, we could not protect the quality of education for our students or the stability of our business.
          <br /><br />
          We ask for your understanding that these rules exist to protect the professionalism of our entire team. That said, MWE deeply values and rewards consistency. <strong>We provide enhanced compensation for teachers who have a proven background from a native English-speaking country, maintain high instructional standards, and keep a perfect attendance record for over a year.</strong> We believe that those who make Maxwell English shine deserve to be recognized and rewarded accordingly. If you are a dedicated professional, these policies will only serve to highlight your value within our community.
        </>
      )
    },
  ],

  tab4: [
    {
      id: 'q18',
      question: 'When and how is payment made?',
      answer: (
        <>
          A: Payments are made once a month via Wise, between the 8th and 13th of each month. If you begin teaching after the 20th of any month, your lesson payment will be processed and paid in the month after next.
          <br /><br />
          For example, if you start on March 22, you will receive your first payment in May.
          If you do not have a Wise account, please create one and send us your <strong>full name</strong> along with the <strong>email address</strong> you used to register the account.
        </>
      ),
    },
    {
      id: 'q19',
      question: 'Does Maxwell deduct taxes from my pay?',
      answer: (
        <>
          A: No. Maxwell does not withhold any taxes. Tutors are responsible for handling their own taxes according to the laws of their country of residence.
        </>
      ),
    },
  ],
};

// 탭별 부연 설명(Accordion 위에 보여줄 문단)
const tabIntro = {
  tab1: (
    <>
      Learn how to connect with our team, set up your tools, and understand your students.
    </>
  ),
  tab2: (
    <>
      Understand lesson format, timing, materials, and expectations during class.
    </>
  ),
  tab3: (
    <>
      Policies for lateness, cancellations, vacations, and no-shows.
    </>
  ),
  tab4: (
    <>
      How to get paid, tax rules, and your responsibilities.
    </>
  ),
};

// 탭 메뉴에 표시될 탭 정보 정의
const tabs = [
  { id: 'tab1', name: 'Getting Started' },
  { id: 'tab2', name: 'Class Policies' },
  { id: 'tab3', name: 'Attendance & Leave' },
  { id: 'tab4', name: 'Payment & Admin' },
];

function App() {
  const [activeTab, setActiveTab] = useState(tabs?.[0]?.id || '');

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const numberedItems = (qnaData?.[activeTab] || []).map((item, index) => ({
    ...item,
    question: `Q${index + 1}. ${item.question}`,
  }));

  return (
    <div className="app-container-wrapper">
      <div className="logo-container">
        <img src={max} alt="캐릭터" className="max-logo" />
        <img src={logo} alt="로고" className="main-logo" />
      </div>

      <div className="app-container">
        <h1>Maxwell English Tutor Policy & Q&A Guide</h1>
        <p>
          Welcome to Maxwell English (MWE)!<br />
          This guide outlines everything you need to know to succeed as a tutor on our platform.
          <br /><br />
          If you have any questions, feel free to reach out to the MWE team via <br />
          admin@maxwellenglish.com
        </p>

        <div className="section-divider" />

        <Tabs tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />

        <div className="content-area">
          {tabIntro?.[activeTab] && (
            <p className="tab-intro">
              {tabIntro[activeTab]}
            </p>
          )}

          <Accordion items={numberedItems} />
        </div>
      </div>

      <p className="footer-note">
        Maxwell English is built on <strong>trust and responsibility.</strong> If you have any questions after reviewing this guide,
        please feel free to reach out to the MWE admin team anytime.
      </p>
    </div>
  );
}

export default App;